module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAw0lEQVR4Xu2asRGAIAADk+08bHVMexejNR6N5w55NuBJ8g1W+XH5/QUAElBOgAqUB4ARpAJUoJyA55yX7S1JVR1sJ8m9ADxS7RhmAUhzCwBAAqgAG8AIYoFiAmgQDaJBNIgGiyUgLIAFsAAW6LZA9hMA1RokAVSADWAEGcFiAsYCWAALYIHiDRQjiAWwABbAAt0WGMcju+qP4Pfg63NkxnHJ2qQ2CImiu/Plf50HQPMArruTABJQToAKlAeAEaQC7RV4AUJGl8O6YFTAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/languageflags/pl.png
// module id = 181
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22